export const CREATE_DIR = 'CREATE_DIR';
export const CREATE_FILE = 'CREATE_FILE';
export const RENAME_NODE = 'RENAME_NODE';
export const DELETE_NODE = 'DELETE_NODE';



/** WEBPACK FOOTER **
 ** ./app/constants/FileTreeTypes.js
 **/